export default {
	methods: {
		getArticleElementHtml: function(item, isRebrush22) {
			jQuery.ajax ({
				url: '/getArticleElement',
				type: 'POST',
				data: JSON.stringify({'element':item, 'rebrush22':isRebrush22}),
				contentType: "application/json; charset=utf-8",
				success: function(data) {
					item.html = data;
				},
				error: function() {alert("error");}
			});
		},
		getSelectChoices: function(successCallback) {
			return jQuery.ajax ({
				url: '/getSelectChoices',
				type: 'GET',
				dataType: "json",
				success: function(data) {
					successCallback(data);
				},
				error: function() {alert("error1");}
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/js/article-helper.js